var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.projects && _vm.data.projects.length)?_c('card-grid',{attrs:{"cardType":"project","cards":_vm.data.projects}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }